export const VIDEO_RECORD = 1;
export const CANNOT_JOIN = 2;
export const CAN_JOIN = 3;
export const EDIT_UNIT = 4;
export const SEND_CONFIRM = 5;
export const PENALTY_TYPE = 3;
export const PENALTY_LATE = 1;

export const TEACHER_CONFIRMED_YES = 1;
export const TEACHER_CONFIRMED_BY_SYSTEM = 2;
export const TEACHER_CONFIRMED_BY_TEACHER = 1;
export const TEACHER_CONFIRMED_NO = 2;
export const STUDENT_CONFIRMED_YES = 1;
export const STUDENT_CONFIRMED_BY_SYSTEM = 2;
export const STUDENT_CONFIRMED_BY_STUDENT = 1;
export const STUDENT_CONFIRMED_NO = 2;
export const RATE_70 = 2;
export const NOT_ABSENCE = 0;
export const TEACHER_ABSENCE = 1;
export const STUDENT_ABSENCE = 2;
export const ABSENCE_TYPES = [
  {
    id: TEACHER_ABSENCE,
    title: 'Teacher absented session',
    content: 'Teacher are request to be absent from this session',
  },
  {
    id: STUDENT_ABSENCE,
    title: 'Student absented session',
    content: 'Student are request to be absent from this session',
  },
];
export const MAKE_UP_CLASS_BY_STUDENT = 2;

export const MAKE_UP_CLASS_BY_TEACHER = 3;
